import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  Button, Popconfirm, message, Icon,
} from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import {
  eliminarFotoNoConformidadAction,
  deseleccionarNoConformidadAction,
} from '../../../state/actions/creators/noconformidades/noconformidades.actioncreator';
import InlineCard from '../components/InlineCard';
import { Box, Text } from '../../shared/components';
import HeaderPageLayout from '../../app/layout/headerPage.layout';
// import PopConfirm from '../../app/components/PopConfirm.component';

class FotosPage extends React.Component {
  constructor(props) {
    super();
    this.imagenActual = null;
  }

  componentWillMount() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  onClickEliminarFotoNc() {
    // ReactDOM.render(PopConfirm);
    // const { eliminarFotoNoConformidadAction, match: { params: { id } } } = this.props;
    // const datos = [];
    // datos.nc_id = id;
    // datos.foto = this.imagenActual.replace('"/>', '').replace('<img src="', '');
    // eliminarFotoNoConformidadAction(datos);
  }


  cancel(e) {
    console.log(e);
  }

  getNavigationButtons() {
    return (
      <Box>
        <Button type="link" shape="circle" onClick={() => this.volverAtras()}>
          {' '}
          <FontAwesomeIcon icon={faArrowLeft} />
        </Button>
      </Box>
    );
  }

  confirm(e) {
    const { props: { title: { _self: { props: { eliminarFotoNoConformidadAction, match: { params: { id } } }, imagenActual } } } } = this;
    const datos = [];
    datos.nc_id = id;

    datos.foto = imagenActual.replace('"/>', '').replace('<img src="', '');
    deseleccionarNoConformidadAction();
    eliminarFotoNoConformidadAction(datos);
  }

  volverAtras() {
    const { history } = this.props;
    history.goBack();
  }

  render() {
    const {
      noConformidades, match: { params: { id, numFoto } }, form,
    } = this.props;
    const { seleccionada } = noConformidades;

    const {
      observaciones,
    } = seleccionada || null;

    let observacionesSinImg = '';
    let imgObservaciones = '';
    let arrayImgs = null;
    if (observaciones) {
      const posImgObservaciones = observaciones.indexOf('<img');
      observacionesSinImg = observaciones.slice(0, posImgObservaciones);
      imgObservaciones = observaciones.slice(posImgObservaciones, observaciones.length);
      imgObservaciones = imgObservaciones.replace('<br><br> ', '');
      arrayImgs = imgObservaciones.split('<img src="');
      if (arrayImgs && (arrayImgs.length > 0)
       && ((arrayImgs[0] === ' ') || (arrayImgs[0] === ''))) {
        arrayImgs.splice(0, 1);
      }

      for (let i = 0; i < arrayImgs.length; i += 1) {
        arrayImgs[i] = arrayImgs[i].replace('<br><br>', '').replace('" alt="" />', '').replace('" />', '');
        arrayImgs[i] = `<img src="${arrayImgs[i]}"/>`;
      }
    }

    if ((arrayImgs.length > 0) && (numFoto !== null)) {
      this.imagenActual = arrayImgs[numFoto];
    } else if (arrayImgs && arrayImgs.length > 0) {
      this.imagenActual = arrayImgs[0];
    }

    // const width = document.body.clientWidth - 64;
    let height = document.body.clientHeight - 220;
    height += 'px';

    return (
      <HeaderPageLayout
        title="No conformidades"
        p={0}
        navigationButton={this.getNavigationButtons()}
      >
        <InlineCard
          headerText="IMAGEN"
          p={0}
          style={{ textAlign: 'center' }}
          content={(
            <Box style={{ textAlign: 'center' }}>
              <div
                dangerouslySetInnerHTML={{ __html: (this.imagenActual.replace('<img ', '<img style="resize: horizontal;/* overflow: hidden; */height: 420px;width: auto;width: auto;height: 420px;" ')) }}
              />
              <Box>
                <Box p={0} py={0} style={{ textAlign: 'center' }}>
                  <Popconfirm
                    title={(
                      <Box style={{ textAlign: 'center' }}>
                        <Icon
                          style={{ fontSize: '48px' }}
                          type="exclamation-circle"
                          theme="twoTone"
                          twoToneColor="#FF7171"
                        />
                        <br />
                        <Text p={3}>
                            ¿Desea eliminar permanentemente esta imagen de la No
                            Conformidad?
                        </Text>
                      </Box>
                    )}
                    onConfirm={this.confirm}
                    onCancel={this.cancel}
                    okText="Eliminar"
                    cancelText="Cancelar"
                    okType="okTypeBtn"
                    placement="top"
                    icon=""
                  >
                    <Button style={{ height: '60px', width: '90%', marginTop: '15px' }} block htmlType="button" className="tertiary">
                      <Text fontWeight="bold">Eliminar</Text>
                    </Button>
                  </Popconfirm>
                </Box>

              </Box>
            </Box>
            )}
        />

      </HeaderPageLayout>
    );
  }
}

function mapStateToProps({ noConformidades }) {
  return {
    noConformidades,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    eliminarFotoNoConformidadAction,
    deseleccionarNoConformidadAction,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(FotosPage);
